// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu7 = () => {
    const { menuDashboard7 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard7?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard7.id,
        title: <FormattedMessage id={`${menuDashboard7.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard7.icon],
        type: menuDashboard7.type,
        children: ChildrenList
    };

    return dashboardList;
};
